/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Ch_SubInputs */

const en_cp_ch_sub = /** @type {(inputs: Cp_Ch_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Like the Solution Challenge or Imagine Cup, without requiring a specific model. Judged on the recorded process, the verified product and real impact.`)
};

const id_cp_ch_sub = /** @type {(inputs: Cp_Ch_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seperti Solution Challenge atau Imagine Cup, tapi tanpa syarat memakai model tertentu. Yang dinilai adalah proses yang tercatat, produk yang terverifikasi, dan dampak nyata.`)
};

/**
* | output |
* | --- |
* | "Like the Solution Challenge or Imagine Cup, without requiring a specific model. Judged on the recorded process, the verified product and real impact." |
*
* @param {Cp_Ch_SubInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_ch_sub = /** @type {((inputs?: Cp_Ch_SubInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Ch_SubInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_ch_sub(inputs)
	return en_cp_ch_sub(inputs)
});